import { Button, Dialog, DialogActions, DialogTitle, Slide, Typography, Box, useTheme, useMediaQuery } from '@mui/material';
/* eslint-disable */
import OtpInput from 'react-otp-input';
import { useState } from 'react';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import React from 'react';
import { handleCatchError } from 'utils/CatchHandler';
import { refreshMpinApi } from 'utils/API/Merchant APIs/MpinApiCalls';
import ForgotMpinDialog from './ForgotMpin';
import Spinner from 'views/Components/LoadingSinner';
const inputStyle = {
    width: '36px',
    height: '42px',
    margin: '0 4px',
    borderRadius: '10px',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    background: 'rgba(255,255,255,0.3)',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
    fontSize: '1.4rem',
    color: '#1A202C',
    textAlign: 'center',
    outline: 'none',
    fontWeight: 500,
    transition: 'all 0.3s ease',
    backdropFilter: 'blur(4px)'
};

const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '0.5rem'
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function MpinChecker({ open, onClose, loginBaseData }) {
    const [mpin, setMpin] = useState('');
    const [forgotOpen, setForgotOpen] = useState(false);
    const [mpinOpen, setMpinOpen] = useState(false);
    const [mpinLoading, setMpinLoading] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const firstInputRef = useRef(null);
    const navigate = useNavigate();
    useEffect(() => {
        if (open && firstInputRef.current) {
            setTimeout(() => {
                firstInputRef.current.focus();
            }, 100);
        }
    }, [open]);

    useEffect(() => {
        setMpinOpen(open);
        setMpin('');
    }, [open]);

    const handleForgotSuccess = () => {
        setMpinOpen(true);
    };

    const handleMpinChange = (value) => {
        if (/^\d*$/.test(value)) {
            setMpin(value);
            if (value.length === 6) {
                handleMpin(value); // pass value
            }
        }
    };

    const handleMpin = async (value) => {
        try {
            setMpinLoading(true);
            const token = localStorage.getItem('accessToken');
            const payload = {
                mpin: value
            };
            const response = await refreshMpinApi(payload, token);
            if (response?.success || response?.status === 200) {
                localStorage.setItem('token', response?.data?.jwt);
                window.location.reload();
                onClose?.();
            }
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
        } finally {
            setMpinLoading(false);
        }
    };

    return (
        <Dialog
            open={mpinOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose?.();
                }
            }}
            aria-describedby="mpin-dialog-description"
            PaperProps={{
                sx: {
                    width: isMobile ? '90vw' : '400px',
                    borderRadius: 5,
                    p: 2.2,
                    textAlign: 'center',
                    background: 'rgba(255, 255, 255, 0.7)',
                    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.18)',
                    maxHeight: '350px',
                    minHeight: 'auto'
                }
            }}
        >
            <DialogTitle
                sx={{
                    fontWeight: 700,
                    fontSize: '1.2rem',
                    letterSpacing: 0.5,
                    mb: 0.5,
                    background: 'linear-gradient(90deg, #042d47, black, yellow)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    display: 'inline-block'
                }}
            >
                Enter your MPIN
            </DialogTitle>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2, fontSize: '1.01rem', fontWeight: 500 }}>
                Please enter the 6-digit secure code
            </Typography>

            <Box display="flex" justifyContent="center" sx={{ mb: 1 }}>
                {open && (
                    <OtpInput
                        value={mpin}
                        onChange={handleMpinChange}
                        numInputs={6}
                        isInputSecure={true}
                        shouldAutoFocus={open}
                        inputStyle={inputStyle}
                        containerStyle={containerStyle}
                        renderSeparator={<span style={{ width: '8px' }} />}
                        renderInput={(props) => <input {...props} />}
                    />
                )}
            </Box>
            <DialogActions sx={{ mt: 1, justifyContent: 'space-between', px: 2 }}>
                <Button onClick={() => navigate('/')} variant="text" size="medium">
                    Logout
                </Button>
                <Button
                    onClick={() => {
                        setForgotOpen(true);
                        setMpinOpen(false); // Close MPIN dialog
                    }}
                    variant="text"
                    size="medium"
                    color="primary"
                >
                    Forgot MPIN?
                </Button>
            </DialogActions>
            <ForgotMpinDialog
                open={forgotOpen}
                onClose={() => setForgotOpen(false)}
                onSuccess={() => {
                    setForgotOpen(false);
                    setMpinOpen(true);
                    setMpin('');
                }}
                onSubmit={(data) => {
                    console.log('Submitted data:', data);
                }}
                data={loginBaseData}
            />
            <Spinner loading={mpinLoading} />
        </Dialog>
    );
}
